module.exports = __webpack_public_path__ + "img/consultation.bfddb19.jpg";